import React from "react";
import Search from "../../../components/Search";

export default function FrequentHistory() {
  const searchHistory = [
    {
      id: 1,
      dateTime: "2025-01-24T10:00:00",
      searchTitle: "Act Title 1",
      count: 10,
    },
    {
      id: 2,
      dateTime: "2025-01-24T11:00:00",
      searchTitle: "Act Title 2",
      count: 15,
    },
    {
      id: 3,
      dateTime: "2025-01-24T12:00:00",
      actNo: "A003",
      searchTitle: "Act Title 3",
      count: 20,
    },
    {
      id: 4,
      dateTime: "2025-01-24T13:00:00",
      actNo: "A004",
      searchTitle: "Act Title 4",
      count: 25,
    },
    {
      id: 5,
      dateTime: "2025-01-24T14:00:00",
      actNo: "A005",
      searchTitle: "Act Title 5",
      count: 30,
    },
  ];

  return (
    <div className="search-history-container">
      <div className="search-history-announcement">
        Here, you can review your past requests, searches, and interactions with
        gazettes, and easily access any previously viewed or downloaded gazettes
      </div>
      <div className="search-history-searchbox">
        <Search />
      </div>
      <div className="search-history-body">
        <div className="ewarta-search-result-body">
          <table style={{ padding: "25px" }}>
            <thead>
              <tr>
                <td>Gazette/Item Name</td>
                <td>Search Count</td>
                <td>Latest Search Date</td>
              </tr>
            </thead>
            <tbody>
              {searchHistory.map((item) => (
                <tr key={item.id}>
                  <td>{item.searchTitle}</td>
                  <td>
                    {item.count} <br />
                    <span
                      style={{
                        color: "#2397F3",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      View All
                    </span>
                  </td>
                  <td>{item.dateTime}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
